import { render } from "./GestioneReclami.vue?vue&type=template&id=0534e01a&scoped=true"
import script from "./GestioneReclami.vue?vue&type=script&lang=js"
export * from "./GestioneReclami.vue?vue&type=script&lang=js"

import "./GestioneReclami.vue?vue&type=style&index=0&id=0534e01a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0534e01a"]])

export default __exports__